import React from "react";
import Icon from "./Icon";

export default function Toast({ message }) {
  if (!message) return null;
  return (
    <div className="toast-wrap">
      <div className="toast"><Icon name="check" size={15} />{message}</div>
    </div>
  );
}
